import styled from "styled-components"

export const SettingSectionWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	gap: 24px;
	padding-bottom: 24px;
	.lastSection {
		.transmissionChannelsContainer {
			font-weight: 400;
			font-size: 12px;
			line-height: 14.4px;
			letter-spacing: 0%;
			p {
				margin: 0;
			}
			.containerCheckBoxs {
				display: flex;
				gap: 20px;
				div {
					display: flex;
					justify-content: flex-start;
					align-items: center;
				}
			}
		}
		.containerCustomTable {
			border: 1px solid #e9e9e7;
			border-radius: 12px;
			.containerSearchInput {
				padding: 16px;
				padding-bottom: 0;
			}
		}
	}
`
